import React from 'react';
import {Link} from 'react-router-dom';
import createLink from "../../../libs/createLink";
import {config} from "../../../config";
import Helmet from "react-helmet";
import {canonical} from "../../../libs/helper";
import {bindActionCreators} from "redux";
import {fetchUsers} from "../../../creators/users";
import {connect} from "react-redux";

import crossMall from "./images/cross-small.png";

import picto1 from "./images/V_pictos-01.svg";
import picto2 from "./images/V_pictos-02.svg";
import picto3 from "./images/V_pictos-03.svg";
import picto4 from "./images/V_pictos-04.svg";
import picto5 from "./images/V_pictos-05.svg";
import picto6 from "./images/V_pictos-06.svg";
import picto7 from "./images/V_pictos-07.svg";
import picto8 from "./images/V_pictos-08.svg";

import img1 from "./images/V-img1.png";
import img2 from "./images/V-img2.png";
import img3 from "./images/V-img3.png";
import img4 from "./images/V-img4.png";
import img5 from "./images/V-img5.png";
import img6 from "./images/V-img6.png";
import img7 from "./images/V-img7.png";
import img8 from "./images/V-img8.png";

import "./Charter.scss";

class Charter extends React.Component {
    constructor(props) {
        super(props);

        this.props.fetchUsers({staff: true});
    }


    render() {

        window.scrollTo(0, 0);
        return (
            <div id="charte-voissa">
                <Helmet>
                    <title>{config.preTitle}Charte d'utilisation{config.postTitle}</title>
                    <link rel="canonical" href={canonical(createLink("charter"), "", "charter")}/>
                </Helmet>
                <div className="charte-banner">
                    <h1>La charte d'utilisation de Voissa</h1>
                    <p>Avant de vous lancer sur Voissa, il est important de lire les règles<br />élémentaires de notre communauté.</p>
                </div>

                <div className="charte-section">
                    <div className="charte-section-img">
                        <div className="charte-section-img-picto">
                            <img src={picto1} alt="" />
                        </div>
                        <img className="charte-section-img-illu" src={img1} alt="" />
                    </div>
                    <div className="charte-section-content">
                        <h2>L’esprit Voissa : liberté, respect et bienveillance</h2>
                        <p>Quand Voissa est né (en 1999 !), nous nous sommes fixé la mission d’offrir un espace de liberté, un jardin secret pour discuter, partager et se dévoiler.</p>
                        <p className="charte-section-content-margin">Nous ne serions pas devenus une communauté si importante si ces valeurs n’étaient pas inscrites dans notre ADN depuis le premier jour.</p>
                        <p>Nous demandons à nos membres d’être respectueux et bienveillants entre eux, dans leurs échanges publics (commentaires, forum etc.) et privés (chat).</p>
                    </div>
                </div>

                <div className="charte-section">
                    <div className="charte-section-img">
                        <div className="charte-section-img-picto">
                            <img src={picto2} alt="" />
                        </div>
                        <img className="charte-section-img-illu" src={img2} alt="" />
                    </div>
                    <div className="charte-section-content">
                        <h2>Les règles élémentaires pour publier dans vos galeries personnelles</h2>
                        <span className="charte-section-content-span">La base c’est de publier des photos et vidéos qui vous représentent, ça fait partie du respect.</span>

                        <p className="charte-section-content-punder">Donc :</p>
                        <div className="charte-section-content-false">
                            <div>
                                <img src={crossMall} alt="" />
                                <div className="charte-section-content-false-txt">
                                    <h1>Pas de contenu trouvé sur internet</h1>
                                    <p>(avec intention d’usurper une identité ou pas).</p>
                                </div>
                            </div>
                        </div>

                        <div className="charte-section-content-false">
                            <div>
                                <img src={crossMall} alt="" />
                                <div className="charte-section-content-false-txt">
                                    <h2>Seulement du contenu qui correspond à votre profil</h2>
                                    <p>Le contenu publié doit correspondre au genre de votre profil (homme, femme, couple...)</p>
                                </div>
                            </div>
                            <div className="charte-section-content-false-desc">
                                <p>Un profil homme ou femme peut seulement publier du contenu de <span>soi-même</span> : seul(e) ou en couple. Le profil
                                couple est réservé à ceux qui publient du contenu de lui, elle ou les deux ensemble,
                                mais ne doit pas être utilisé par une seule personne.</p>
                                <p><span>Exemple :</span> Un profil "homme" peut publier du contenu de lui-même (homme) ou en couple (s'il apparaît sur le média avec son/sa partenaire) mais il est interdit de publier du contenu d'une femme seule, même si c'est sa partenaire.</p>
                            </div>
                        </div>

                        <div className="charte-section-content-false">
                            <div>
                                <img src={crossMall} alt="" />
                                <div className="charte-section-content-false-txt">
                                    <h2>Pas de contenu qui ne vous représente pas</h2>
                                    <p>(pas de dessin, photos humoristiques, citations etc.).</p>
                                </div>
                            </div>
                            <div className="charte-section-content-false-desc">
                                <p>Une exception peut être accordée aux <span>illustrateurs</span> pour qu’ils puissent donner une exposition suffisante à leur travail ainsi qu’aux <span>photographes</span>.</p>
                            </div>
                        </div>
                        <div className="charte-section-content-false">
                            <div>
                                <img src={crossMall} alt="" />
                                <div className="charte-section-content-false-txt">
                                    <h2>Pas de contenu publié à l’insu d’une tierce personne.</h2>
                                </div>
                            </div>
                            <div className="charte-section-content-false-desc">
                                <p>Une tolérance peut être accordée à condition que la personne apparaisse sans élément distinctif (visage entre autres).</p>
                                {/*<p className="charte-section-content-margin">Si la personne présente est reconnaissable, il est <span>obligatoire</span> de l’ajouter comme co-publicateur au moment de l’upload.</p>*/}
                                <p>Cette règle vaut pour les dédicaces, c'est-à-dire les médias d’hommes qui se masturbent sur un contenu physique (papier, écran) d’une autre personne.</p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="charte-section">
                    <div className="charte-section-img">
                        <div className="charte-section-img-picto">
                            <img style={{width: "45px"}}  src={picto3} alt="" />
                        </div>
                        <img className="charte-section-img-illu" src={img3} alt="" />
                    </div>
                    <div className="charte-section-content">
                        <h2>La publication de médias sur le forum ou les articles</h2>
                        <p>C’est l’unique endroit pour publier des contenus du net, c’est-à-dire des contenus qui ne vous appartiennent pas.</p>
                        <p className="charte-section-content-margin">Vous avez le droit de publier ce type de contenu, sous votre entière responsabilité.</p>
                        <p>Bien sûr ce n’est pas une raison pour le faire à l’insu d’une personne qui n’est pas consentante. Nous sommes très vigilants sur ce point. </p>
                    </div>
                </div>

                <div className="charte-section">
                    <div className="charte-section-img">
                        <div className="charte-section-img-picto">
                            <img src={picto4} alt="" />
                        </div>
                        <img className="charte-section-img-illu" src={img4} alt="" />
                    </div>
                    <div className="charte-section-content">
                        <h2>La pub, c’est non !</h2>
                        <p>On ne vient pas sur Voissa pour faire de la publicité, donc que la démarche soit marchande (Cam etc.) ou pas (Email, Snap, WhatsApp etc.) c’est totalement interdit.</p>
                        <p className="charte-section-content-margin">Bien entendu vous avez le droit de partager des URLs de sites externes à titre « informatif » (Youtube, Wikipedia etc.).</p>
                    </div>
                </div>

                <div className="charte-section">
                    <div className="charte-section-img" style={{marginTop: "60px"}}>
                        <div className="charte-section-img-picto">
                            <img src={picto5} alt="" />
                        </div>
                        <img className="charte-section-img-illu" src={img5} alt="" />
                    </div>
                    <div className="charte-section-content">
                        <h2>Tout ce qui semble évident mais que nous allons écrire quand même</h2>
                        <p className="charte-section-content-punder">Il est formellement interdit :</p>
                        <div className="charte-section-content-false">
                            <div>
                                <img src={crossMall} alt="" />
                                <div className="charte-section-content-false-txt">
                                    <h2>De publier du contenu qui ne respecte pas la dignité humaine (Inceste,simulation de viol etc.)<br />ou les lois en vigueur en France (Pédophilie, Zoophilie, Racisme, Homophobie, Contenu piraté etc.).</h2>
                                </div>
                            </div>
                        </div>
                        <div className="charte-section-content-false">
                            <div>
                                <img src={crossMall} alt="" />
                                <div className="charte-section-content-false-txt">
                                    <h2>De publier du contenu ou apparaissent des excréments, du contenu jugé trop hard, du sang ou tout autre élément qui révulsera une partie de notre communauté.</h2>
                                </div>
                            </div>
                        </div>
                        <div className="charte-section-content-false">
                            <div>
                                <img src={crossMall} alt="" />
                                <div className="charte-section-content-false-txt">
                                    <h2>D’avoir plusieurs comptes avec l’ambition de tromper d’autres membres.</h2>
                                </div>
                            </div>
                        </div>
                        <div className="charte-section-content-false">
                            <div>
                                <img src={crossMall} alt="" />
                                <div className="charte-section-content-false-txt">
                                    <h2>Aussi, nous n’acceptons pas des photos de couverture ou avatars présentant du contenu hard avec parties génitales.</h2>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="charte-section">
                    <div className="charte-section-img" style={{marginTop: "60px"}}>
                        <div className="charte-section-img-picto">
                            <img src={picto6} alt="" />
                        </div>
                        <img className="charte-section-img-illu" src={img6} alt="" />
                    </div>
                    <div className="charte-section-content">
                        <h2>Les sanctions</h2>
                        <p className="charte-section-content-punder">Il n’y a pas de règle écrite dans le marbre pour juger une action.<br />La sanction est appréciée en fonction de la gravité des faits reprochés et bien entendu du contexte.</p>
                        <div className="charte-section-content-exemple">
                            <h2>exemple un</h2>
                            <p>Un contenu du net publié en galerie pour partager une photo qui vous plaît n’est pas aussi grave que si vous faites croire que cette même photo vous représente.</p>
                        </div>
                        <div className="charte-section-content-exemple">
                            <h2>exemple deux</h2>
                            <p>Un commentaire insultant sur un média ne sera pas jugé « hors charte » si le propriétaire de celui-ci apprécie cette démarche et le demande explicitement dans le titre ou la description.</p>
                        </div>

                    </div>
                </div>

                <div className="charte-section">
                    <div className="charte-section-img">
                        <div className="charte-section-img-picto">
                            <img src={picto7} alt="" />
                        </div>
                        <img className="charte-section-img-illu" src={img7} alt="" />
                    </div>
                    <div className="charte-section-content">
                        <h2>La certification</h2>
                        <p>Elle ne s’impose pas aux membres de la communauté, chacun choisit de se certifier ou pas.</p>
                        <p className="charte-section-content-margin">A tout moment nous nous réservons le droit en cas de doute de demander à un membre de certifier son compte ou celui de la personne co-publiée.</p>
                        <p>En attendant, les contenus suspects sont désactivés et la capacité à publier du contenu enlevée.</p>
                    </div>
                </div>

                <div className="charte-section">
                    <div className="charte-section-img">
                        <div className="charte-section-img-picto">
                            <img src={picto8} alt="" />
                        </div>
                        <img className="charte-section-img-illu" src={img8} alt="" />
                    </div>
                    <div className="charte-section-content">
                        <h2>L’équipe de modération.</h2>
                        <p>C’est une équipe de bénévoles qui aide Voissa avec passion. A ce titre nous demandons que le respect à leur égard soit total.</p>
                        <p className="charte-section-content-margin">Si vous n’êtes pas d’accord, engagez le dialogue, les dénigrements et comportements agressifs ne seront pas tolérés.</p>
                        <p>L’équipe de modération est une équipe humaine et à l’écoute, appuyez-vous sur eux en cas de question sur la charte du site :</p>
                        <div className="charte-section-content-list">
                            <ul>
                                <h2>Les admins de Voissa :</h2>
                                {this.props.usersInitialized ? (
                                    this.props.users.filter(user=> user.role ==="administrator").map(user=>(
                                        <li key={user._id}>
                                            <Link to={createLink("userProfile", user)}>{user.username}</Link>
                                        </li>))
                                ) : null}
                            </ul>
                            <ul>
                                <h2>Nos modérateurs:</h2>
                                {this.props.usersInitialized ? (
                                    this.props.users.filter(user=> user.role ==="moderator").map(user=>(
                                        <li key={user._id}>
                                            <Link to={createLink("userProfile", user)}>{user.username}</Link>
                                        </li>))
                                ) : null}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        users: state.users.data,
        usersLoading: state.users.loading,
        usersInitialized: state.users.initialized,

        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUsers
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(Charter);
